import Link from "next/link";
import { useRouter } from "next/router";

export default function CustomLink(props) {
  const router = useRouter();
  const regex = new RegExp("http(.?):\\/\\/", "gm");
  if (!props.href) {
    return <a {...props}>{props.children}</a>;
  }

  if (props.external || regex.test(props.href)) {
    const target =
      props.target !== undefined
        ? props.target
        : regex.test(props.href)
          ? "_blank"
          : undefined;
    return (
      <a {...props} rel="noopener noreferrer" target={target}>
        {props.children}
      </a>
    );
  }

  // Check if href already includes a locale prefix (e.g., /en/, /pt/)
  // This prevents double-prefixing when routerHandler already added the locale
  const localePattern = /^\/[a-z]{2}(\/|$)/;
  const hrefHasLocale = localePattern.test(props.href);

  // routerHandler omits the prefix for the default locale; only pass `locale` to
  // Next Link for non-default locales so SSR and client hrefs stay in sync.
  const linkLocale = (() => {
    if (hrefHasLocale) return false;
    if (props.locale !== undefined) {
      return props.locale === router.defaultLocale ? false : props.locale;
    }
    if (router.locale && router.locale !== router.defaultLocale) {
      return router.locale;
    }
    return false;
  })();

  return (
    <Link
      href={props.href}
      locale={linkLocale}
      passHref={true}
      legacyBehavior
      target={props.target}
    >
      <a {...props}> {props.children}</a>
    </Link>
  );
}
